// extracted by mini-css-extract-plugin
export default {"title":"_09Resume_title__MwNb9","extraContent":"_09Resume_extraContent__erCqB"};